import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import {
  Button,
  Card,
  CardHeader,
  CardSection,
  Gutter,
  Layout,
  LayoutItem,
  SmallHeader,
  Suspense,
  useApi,
} from '@axiom/ui';
import type { Candidate, CandidateLanguage } from '@axiom/validation';

import { CandidateLanguageUtil } from '../../utils/candidate-language-util';
import { CandidateLanguagesApi } from '../../api/candidate-languages-api';

import { LanguagesGroup } from './LanguagesGroup';
import { LanguagesBannerPrompt } from './LanguagesBannerPrompt';
import { LanguagesItemEdit } from './LanguagesItemEdit';

export const Languages = ({
  candidateId,
}: {
  candidateId: Candidate['id'];
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [languageEdit, setLanguageEdit] = useState(false);
  const [{ data: candidateLanguages }] = useApi(
    CandidateLanguagesApi.readLanguages(candidateId)
  );

  const handleEditClick = () => {
    setLanguageEdit(true);
  };

  const handleModalClose = () => {
    setLanguageEdit(false);
  };

  useEffect(() => {
    if (searchParams.get('modal') === 'language') {
      handleEditClick();
      setSearchParams({}, { replace: true });
    }
  }, [searchParams]);

  return (
    <Suspense>
      <Card name="LANGUAGES">
        <CardHeader>
          <Layout position="middle">
            <LayoutItem fluid>
              <SmallHeader name="PENDO-PROFILE-SUMMARY">Languages</SmallHeader>
            </LayoutItem>
            <Button
              name="LANGUAGE_ADD_BUTTON"
              pattern="secondary"
              variation="minimal"
              icon="plus"
              onClick={() => {
                handleEditClick();
              }}
            >
              Add
            </Button>
          </Layout>
        </CardHeader>
        {candidateLanguages.length === 0 && (
          <CardSection>
            <LanguagesBannerPrompt onOpenEdit={handleEditClick} />
            <Gutter bottom="16px" />
          </CardSection>
        )}
        {candidateLanguages.length > 0 &&
          Object.entries(
            CandidateLanguageUtil.groupByCategories(candidateLanguages)
          ).map(([languageName, groupings]) => {
            return (
              <LanguagesGroup
                key={languageName}
                candidateId={candidateId}
                candidateLanguages={candidateLanguages}
                languageName={languageName}
                languageGroups={
                  groupings as Record<string, CandidateLanguage[]>
                }
              />
            );
          })}
        {!!languageEdit && (
          <LanguagesItemEdit
            candidateId={candidateId}
            candidateLanguages={candidateLanguages}
            onClose={() => {
              handleModalClose();
            }}
          />
        )}
      </Card>
    </Suspense>
  );
};
